class SorterService {
    // ------------------------------------------------------------
    // Utility: Convert Finnish weekday name → JS weekday number
    // ------------------------------------------------------------
    weekdayToNumber(weekday) {
      const map = {
        Sunnuntai: 0,
        Maanantai: 1,
        Tiistai: 2,
        Keskiviikko: 3,
        Torstai: 4,
        Perjantai: 5,
        Lauantai: 6,
      };
      return map[weekday?.trim()] ?? -1;
    }
  
    // ------------------------------------------------------------
    // Return today's Finnish weekday name
    // ------------------------------------------------------------
    todayName() {
      const today = new Date().getDay(); // 0=Sun, 1=Mon...
      const map = [
        "Sunnuntai",
        "Maanantai",
        "Tiistai",
        "Keskiviikko",
        "Torstai",
        "Perjantai",
        "Lauantai",
      ];
      return map[today];
    }
  
    // ------------------------------------------------------------
    // Normalize a time string (handles "18.00", "18:00", "18,00")
    // ------------------------------------------------------------
    normalizeTimeString(time) {
      if (!time) return "00:00";
      const match = time.toString().trim().match(/(\d{1,2})[.:,]?(\d{0,2})/);
      if (!match) return "00:00";
      const hours = match[1].padStart(2, "0");
      const minutes = (match[2] || "00").padEnd(2, "0");
      return `${hours}:${minutes}`;
    }
  
    // ------------------------------------------------------------
    // Convert normalized time string → total minutes
    // ------------------------------------------------------------
    timeToMinutes(time) {
      const [h, m] = this.normalizeTimeString(time).split(":").map(Number);
      return h * 60 + m;
    }
  
    // ------------------------------------------------------------
    // Filter meetings by weekday name (Finnish)
    // ------------------------------------------------------------
    filterByDayName(meetings, dayName) {
      if (!Array.isArray(meetings)) return [];
      return meetings.filter(
        (m) => m.weekday?.trim()?.toLowerCase() === dayName.toLowerCase()
      );
    }
  
    // ------------------------------------------------------------
    // Sort meetings by how soon they start (from current time)
    // ------------------------------------------------------------
    sortBySoonest(meetings) {
      const now = new Date();
      const nowMinutes = now.getHours() * 60 + now.getMinutes();
  
      return [...meetings].sort((a, b) => {
        const aTime = this.timeToMinutes(a.alkamisaika);
        const bTime = this.timeToMinutes(b.alkamisaika);
        const aDiff = (aTime - nowMinutes + 1440) % 1440;
        const bDiff = (bTime - nowMinutes + 1440) % 1440;
        return aDiff - bDiff;
      });
    }
  }
  
  export default new SorterService();
  